import { useEffect, useState } from 'react';

const breakpoint = 1024;

export const useMobile = () => {

    const [isMobile, setMobile] = useState(determineIfMobile());

    useEffect(() => {
        if (process.env.REACT_APP_TO_BUILD !== 'website-server') {
            const onResize = () => setMobile(determineIfMobile());
            onResize();
            window.addEventListener('resize', onResize);
            return () => window.removeEventListener('resize', onResize);
        }
    }, []);

    return isMobile;
};

const determineIfMobile = () => {

    if (process.env.REACT_APP_TO_BUILD !== 'website-server') {
        return window.innerWidth < breakpoint && window.devicePixelRatio > 1;
    }

    return false;
};